import React from 'react';

export default function TypingIndicator() {
  return (
    <div className="message-wrapper">
      <div className="message-content premium-glow">
        <div className="typing-indicator">
          <span className="typing-dot"></span>
          <span className="typing-dot"></span>
          <span className="typing-dot"></span>
        </div>
      </div>
    </div>
  );
}
